var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from "./NumericalWebSearchItem.module.scss";
import chatBotApi from "../../api/chatbot";
import { currentSessionId } from "../../stores/reducers/chatReducer";
import { useSelector } from "react-redux";
import { getSettings } from "../../constants/setting";
import { isLanguageRTL } from "../../../../constants";
var NumericalWebSearchItem = function (props) {
    var title = props.title, link = props.link, snippet = props.snippet, counter = props.counter, bot_item_id = props.bot_item_id, language = props.language;
    var sessionId = useSelector(currentSessionId);
    var onClicked = function (e) {
        if (!e.ctrlKey)
            e.preventDefault();
        chatBotApi.logVisitedSearchResult(sessionId, title, link, bot_item_id);
        if (!e.ctrlKey)
            window.open(link, '_top');
    };
    return _jsx(_Fragment, { children: _jsx("a", __assign({ href: link, onClick: onClicked, className: styles.itemLink }, { children: _jsxs("div", __assign({ className: "".concat(styles.text, " ").concat(isLanguageRTL(language) && styles.rtl) }, { children: [_jsx("span", __assign({ className: styles.link }, { children: link })), _jsxs("span", __assign({ className: styles.title, style: { color: getSettings().primary_color } }, { children: ["#", counter, " ", title] })), _jsx("div", __assign({ className: styles.description }, { children: snippet }))] })) })) });
};
export default NumericalWebSearchItem;
